import React from "react";

interface RescanModalProps {
  show: boolean;
  /** Whether the rescan operation is in progress. */
  isRescanning?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Rescan phone number confirmation dialog.
 * Matches the MVC Kendo Dialog exactly:
 *   Title: "Rescan phone number(s)"
 *   Body:  "Are you sure you want to rescan the selected phone numbers?"
 *   Buttons: Cancel (secondary) + Ok (primary)
 */
const RescanModal: React.FC<RescanModalProps> = ({
  show,
  isRescanning = false,
  onConfirm,
  onCancel,
}) => {
  if (!show) return null;

  return (
    <div
      className="modal d-block"
      tabIndex={-1}
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog" style={{ maxWidth: 500 }}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Rescan phone number(s)</h5>
            <button type="button" className="btn-close" onClick={onCancel} disabled={isRescanning} />
          </div>
          <div className="modal-body">
            {isRescanning ? (
              <div className="d-flex align-items-center gap-2">
                <span className="spinner-border spinner-border-sm" />
                <span>Rescanning...</span>
              </div>
            ) : (
              <p>Are you sure you want to rescan the selected phone numbers?</p>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCancel}
              disabled={isRescanning}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={onConfirm}
              disabled={isRescanning}
            >
              Ok
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RescanModal;
